import type { AnalyticsContextI } from "./context";
import { pushToDataLayer } from "./pushToDataLayer";

export function pushAnalyticsContext(context: AnalyticsContextI) {
  const { type, ...layerData } = context;
  pushToDataLayer(layerData);
}
